module.exports = __webpack_public_path__ + "img/amx-1.e1b7e7e3.jpg";